import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { NgProgress } from '@ngx-progressbar/core';
import { forkJoin } from 'rxjs';
import { User } from 'src/app/models/user';
import { AppState } from 'src/app/services/app.service';
import { DocumentsService } from 'src/app/services/documents.service';
import { UserService } from 'src/app/dataServices/userService';
import { DocumentModel } from './documents.model';

@Component({
    selector: 'self-ins-documents',
    templateUrl: './documents-page.component.html',
    styleUrls: ['./documents-page.component.scss']
})

export class DocumentsPageComponent implements OnInit, AfterViewInit {
    @ViewChild(MatSort) public sort: MatSort | undefined;
    public user: User = this.appState.user.getValue();
    public documents = new MatTableDataSource<DocumentModel>([]);
    public docCols: string[] = ['type', 'dateCreated', 'fileName', 'source', 'links'];
    public qnum = 0;
    public qsuffix = '';
    public policyDocs = true;
    public insuredDocs = true;
    constructor(private activeRouter: ActivatedRoute,
        private appState: AppState,
        private documentsDataService: DocumentsService,
        private userService: UserService,
        private progressBar: NgProgress) {
            
        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];

            this.progressBar.ref().start();
            forkJoin([
                this.documentsDataService.getDocuments('FILEREG', Number(this.qnum).toFixed(2)),
                this.documentsDataService.getDocuments('INSUREDS', Number(this.qnum).toFixed(2)),
                this.userService.getQuoteByQnumQsuffix(this.qnum, this.qsuffix),
            ]).subscribe({
                    next: (data) => {
                        const [policyDocs, insuredDocs, quote] = data;
                        
                        let quoteSource = quote.polNum ? quote.polNum : 'Quote';

                        policyDocs.map(obj => {
                            obj.documentType = 'FILEREG';
                            obj.source = quoteSource;
                        });

                        insuredDocs.map(obj => {
                            obj.documentType = 'INSURED',
                            obj.source = 'Insured'
                        });
                        
                        this.documents.data = policyDocs.concat(insuredDocs);

                        for (const doc of this.documents.data) {
                            const isDraft = doc.folder === 'D';
                            doc.iconClass = this.documentsDataService.getIconForDocument(
                                doc.fileLocation,
                                doc.subTable,
                                isDraft
                            );
                        }
                        this.progressBar.ref().complete();
                    }
            });
        });
    }

    ngOnInit() {
        this.documents.sortingDataAccessor = (item, property) => {
            if (property === 'type') {
                return item.iconClass;
            }
            if (property === 'fileName') {
                return item.description;
            }
            else {
                // @ts-ignore
                return item[property];
            }
        };
        this.documents.filterPredicate =
            (data: DocumentModel, filter: string) => !filter || data.documentType === filter;
    }

    ngAfterViewInit() {
        this.documents.sort = this.sort || null;
    }

    public toggleDocTypes(type: string, hide: boolean): void {
        this.documents.filter = !hide && type || '';
    }

    public download(fileLocation: string, type: string, id: number) {
        switch (type) {
            case 'jetfileicon jetfileicon-email':
            case 'jetfileicon jetfileicon-note':
            case 'jetfileicon jetfileicon-new disabled':
                break;
            case 'jetfileicon jetfileicon-video':
            case 'jetfileicon jetfileicon-office-powerpoint':
            case 'jetfileicon jetfileicon-office-word':
            case 'jetfileicon jetfileicon-office-excel':
            case 'jetfileicon jetfileicon-pdf':
            case 'jetfileicon jetfileicon-image-document':
            case 'jetfileicon jetfileicon-text-document':
                this.progressBar.ref().start();
                this.documentsDataService
                    .getDocumentContent(id)
                    .subscribe((data: any) => {
                        const urlCreator = window.URL || (window as any).webkitURL;
                        const blob = new Blob([data]);
                        const fileUrl = urlCreator.createObjectURL(blob);
                        const result = (fileLocation || 'unknown').match(/[^/]*$/g);
                        const fileName = result ? result.shift() : null;
                        
                        const a = document.createElement('a');
                        document.body.appendChild(a);
                        a.href = fileUrl;
                        a.download = fileName as string;
                        a.click();
                        window.URL.revokeObjectURL(fileUrl);

                        this.progressBar.ref().complete();
                    });

                break;
            default:
                break;
        }
    }
}
